import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, } from "@mui/material"
import { useMemo, useState } from "react"
import { useQuery } from "react-query"
import axiosClient from "../../../../../../lib/axios"
import useDebounce from "../../../../../../lib/useDebounce"
import { InputProdutoSazonalidade } from "."
import SearchIcon from "@mui/icons-material/Search";
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery"
import DisplayNotFoundInfo from "../../../../../../components/DisplayNotFindInfo"

export default function DialogCrudSazonalidade({
    open,
    handleClose,
    onVincular
    // onSubmit
}: DialogCrudSazonalidadeProps) {

    const [produtosSelecionados, setProdutosSelecionados] = useState<InputProdutoSazonalidade[]>([])
    const [palavraChave, setPalavraChave] = useState<string>("")
    const debouncedKeyword = useDebounce(palavraChave)

    //queries
    const { data, isFetching } = useQuery({
        queryKey: ['/cadastros/pesquisar-produtos', debouncedKeyword],
        queryFn: () => axiosClient.get('/cadastros/pesquisar-produtos', {
            params: {
                limit: 10,
                pesquisar: debouncedKeyword
            }
        }),
        keepPreviousData: true,
    });
    const dataProdutos = useMemo(() => {
        return data?.data.data || [];
    }, [data]);
    //

    //funcoes manipuladoras
    const handleChange = (codigo: number, nome: string, checkbox: boolean) => {
        let newSelecionados: Array<InputProdutoSazonalidade> = [...produtosSelecionados];
        const params = {
            codigo: Number(codigo),
            nome,
        }
        if (!checkbox) {
            newSelecionados = newSelecionados.filter((i) => i.codigo !== codigo);
        }

        if (checkbox) {
            let index = newSelecionados.findIndex((i) => i.codigo === codigo);
            if (index < 0) {
                newSelecionados.push(params)
            } else {
                newSelecionados[index] = params
            }
        }
        setProdutosSelecionados(newSelecionados)
    }
    //

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">
                Vincular produtos
            </DialogTitle>
            <DialogContent>
                <TextField
                    margin="normal"
                    value={palavraChave}
                    fullWidth
                    label="Pesquisar"
                    slotProps={{ input: { endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment> } }}
                    onChange={(e) => setPalavraChave(e.target.value)}
                />
                {
                    isFetching &&
                    <Box width={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                        <LoadingApiQuery />
                    </Box>
                }
                {
                    !isFetching && dataProdutos.length <= 0 &&
                    <DisplayNotFoundInfo
                        label="Nenhum produto foi encontrado para listar"
                        variant="caption"
                        justifyContent="center"
                    />
                }
                {
                    !isFetching && dataProdutos.length > 0 &&
                    <TableContainer>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="right" />
                                    <TableCell><b>Código</b></TableCell>
                                    <TableCell><b>Nome</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    dataProdutos.map((item: any, index: number) => {
                                        let selecionado = produtosSelecionados ? produtosSelecionados.find((produto) => produto.codigo === Number(item.id)) : null;

                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell align="right">
                                                    <Checkbox
                                                        checked={selecionado ? true : false}
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                            handleChange(item.id, item.nome, event.target.checked);
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {item.id}
                                                </TableCell>
                                                <TableCell>
                                                    {item.nome}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                }

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    onClick={() => {
                        onVincular(produtosSelecionados);
                        handleClose();
                    }}
                    disabled={!produtosSelecionados}
                >
                    Vincular
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogCrudSazonalidadeProps {
    open: boolean,
    handleClose: () => void,
    onChangeCheckbox: (codigo: number, nome: string, valor: boolean) => void,
    onVincular: (produtos: InputProdutoSazonalidade[]) => void
}